export default __webpack_public_path__ + "static/media/Group.75ac65a6.svg";